import {MyAds} from './MyAds';

export default MyAds;